import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
import { t } from '../utils/translations';
import { Star } from 'lucide-react';
export function Testimonials() {
  const {
    lang
  } = useLanguage();
  const text = t[lang].testimonials;
  return <section className="py-24 bg-gray-50 relative overflow-hidden" data-id="element-600">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-601">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-gray-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob" data-id="element-602"></div>
        <div className="absolute top-48 -right-24 w-96 h-96 bg-gray-300 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000" data-id="element-603"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-604">
        <div className="text-center mb-20" data-id="element-605">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          type: 'spring',
          stiffness: 100,
          damping: 15
        }} className="text-4xl md:text-6xl font-condensed font-black text-mf-black uppercase tracking-tight mb-6" data-id="element-606">
            {text.title}
          </motion.h2>
          <motion.div initial={{
          width: 0
        }} whileInView={{
          width: 96
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.8
        }} className="h-1.5 bg-mf-yellow mx-auto rounded-full" data-id="element-607"></motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-608">
          {text.reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          y: 0,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15,
          type: 'spring',
          stiffness: 100,
          damping: 15
        }} className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100 flex flex-col h-full" data-id="element-609">
              {/* Header: Avatar, Name, Time, Google Logo */}
              <div className="flex items-start justify-between mb-4" data-id="element-610">
                <div className="flex items-center space-x-4" data-id="element-611">
                  <div className={`w-12 h-12 rounded-full ${review.color} flex items-center justify-center text-white font-bold text-xl shadow-inner`} data-id="element-612">
                    {review.name.charAt(0)}
                  </div>
                  <div data-id="element-613">
                    <div className="font-bold text-gray-900 text-lg leading-tight" data-id="element-614">
                      {review.name}
                    </div>
                    <div className="text-sm text-gray-500 mt-0.5" data-id="element-615">
                      {review.timeAgo}
                    </div>
                  </div>
                </div>
                {/* Google G Logo SVG */}
                <div className="w-6 h-6 flex-shrink-0" data-id="element-616">
                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-617">
                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-618" />
                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-619" />
                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-620" />
                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-621" />
                  </svg>
                </div>
              </div>

              {/* Stars */}
              <div className="flex space-x-1 mb-4" data-id="element-622">
                {[...Array(5)].map((_, i) => <Star key={i} size={18} className="text-[#FBBC04] fill-current" data-id="element-623" />)}
              </div>

              {/* Review Text */}
              <p className="text-gray-700 text-base leading-relaxed flex-grow" data-id="element-624">
                {review.quote}
              </p>

              {/* Footer Badge */}
              <div className="mt-6 pt-4 border-t border-gray-100 flex items-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-625">
                <span className="bg-gray-100 px-2 py-1 rounded" data-id="element-626">
                  Google Review
                </span>
                <span className="mx-2" data-id="element-627">•</span>
                <span data-id="element-628">{review.location}</span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}